export default {
  US_MASQUERADE: 'US_MASQUERADE',
  US_USER_AUTH_TOKEN: 'US_USER_AUTH_TOKEN',
  US_USER_OBJECT: 'US_USER_OBJECT',
  US_USER_REFRESH_TOKEN: 'US_USER_REFRESH_TOKEN',
};
